export interface CalendlyAnswer {
  q: string;
  a: string;
}

const MARKER = /^--- Réponses Calendly ---\s*$/m;

/**
 * Lit le bloc `--- Réponses Calendly ---` stocké dans `prospects.context`.
 * Lignes `• question : réponse`, découpées au PREMIER « : ». Le texte avant le marqueur
 * (notes saisies) est ignoré.
 */
export function parseCalendlyBlock(context: string | null): CalendlyAnswer[] {
  if (!context) return [];
  const m = MARKER.exec(context);
  if (!m) return [];
  const out: CalendlyAnswer[] = [];
  for (const raw of context.slice(m.index + m[0].length).split(/\r?\n/)) {
    const line = raw.trim();
    if (!line.startsWith("•")) continue;
    const body = line.slice(1).trim();
    const i = body.indexOf(" : ");
    if (i < 0) continue;
    const q = body.slice(0, i).trim();
    const a = body.slice(i + 3).trim();
    if (q) out.push({ q, a });
  }
  return out;
}
